namespace Core {

    interface HolidaySearchRequest {
        ArrivalAirports?: string[];
        DepartureAirports: string[];
        DepartureDate: string;
        ReturnDate: string;
        Destination: {
            Type: number;
            Id: number;
        };
        Rooms: {
            Adults: number;
            ChildAges: number[];
        }[];
        Cabin: number;
        IsDirectFlight: boolean;
        PreferredCarrierCodes: string[];
        DomainId: number;
        CultureCode: string;
        CurrencyCode: string;
    }

    interface HolidaySearchResult {
        HolidaySearchId?: string;
        FlightSearchId?: string;
        PackageId?: string;
        KidsGoFree?: boolean;
    }

    interface HotelDates {
        CheckInDate: string;
        CheckOutDate: string;
    }

    class HolidaySearch {

        private searchUrl: string = '/api/holidays/createsearch';
        private adjustUrl: string = '/api/holidays/adjusthoteldates';

        constructor(
            private searchUnitService: Search.SearchUnitService,
            private occupancyService,
            private $http: ng.IHttpService,
        ) {
        }

        private getRequest(parameters): HolidaySearchRequest {
            return <HolidaySearchRequest> {
                DepartureAirports: this.searchUnitService.getDepartureAirports(),
                DepartureDate: this.searchUnitService.startDate(this.searchUnitService.flight),
                ReturnDate: this.searchUnitService.endDate(this.searchUnitService.flight),
                Destination: this.searchUnitService.getDestination(),
                Rooms: this.occupancyService.getOccupancy(),
                Cabin: this.searchUnitService.getCabin(),
                PreferredCarrierCodes: _.get(parameters, 'prefilterAirlines', []),
                IsDirectFlight: !!_.get(parameters, 'prefilterDirectFlights'),
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                ArrivalAirports: this.searchUnitService.getArrivalAirports()
            };
        }

        createSearch(parameters): ng.IHttpPromise<HolidaySearchResult> {
            return this.$http.post<HolidaySearchResult>(this.searchUrl, this.getRequest(parameters));
        }

        adjustHotelDates(HotelSearchId: string, dates: HotelDates) {
            return this.$http.post(this.adjustUrl, _.defaults({ HotelSearchId }, dates))
                .then(({ data }) => data);
        }
    }

    angular
        .module('TR')
        .service('holidaySearch', HolidaySearch);
}
